var map = {
	"./01_hul.jpg": 4189,
	"./02_Marico.png": 7774,
	"./03_RB@3x.png": 1697,
	"./04_ITC@3x.png": 4104,
	"./05_TATA CP@3x.png": 7086,
	"./06_Lakme@3x.png": 1641,
	"./07_REDbull.png": 6729,
	"./08_Cavinkare.png": 6239,
	"./09_Britannia.png": 176,
	"./10_PepsiCo_logo.svg": 4943,
	"./11_Dabur.png": 6637,
	"./12_Mars.png": 3323,
	"./13_Nivea.png": 2854,
	"./14_J_j.png": 6934,
	"./15_ColPal.png": 8744,
	"./Hersheys.png": 4067,
	"./Jothy-labs.png": 8381,
	"./Zydus.png": 9933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8180;